import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import { RoundLoader } from 'components/widgets/state-indicators/loader';
import EmptyPagePlaceholder from './empty-page-placeholder';


export default function PageContent({ className, children, fetching, showEmptyText, emptyText, emptyTextIcon, ...props }) {
  return (
    <div {...props} className={classNames(className, 'page-content', { 'page-content-empty': showEmptyText })}>
      { fetching &&
        <RoundLoader color="#34495e" className="page-loader" />
      }
      { showEmptyText &&
        <EmptyPagePlaceholder src={emptyTextIcon}>{emptyText}</EmptyPagePlaceholder>
      }
      { (!fetching && !showEmptyText) &&
        children
      }
    </div>
  );
}

PageContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  fetching: PropTypes.bool,
  showEmptyText: PropTypes.bool,
  emptyText: PropTypes.node,
  emptyTextIcon: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/page/page-content.js